import React from 'react'
import LazyLoad from 'react-lazyload'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import '../../styles/@shared/lazy-section.scss'

const LazySection = ({
  height = 300,
  offset = -100,
  children,
  sitecoreContext,
  id = '',
}) => {
  return (
    <section
      style={{ padding: '0px' }}
      id={id}
      className={
        id === '4b62da75-44ec-41ca-a0a5-c54565e5feb2'
          ? 'lazy-section--margin'
          : 'lazy-section'
      }
    >
      {sitecoreContext?.pageEditing ? (
        children
      ) : (
        <LazyLoad once={true} offset={offset} height={height}>
          {children}
        </LazyLoad>
      )}
    </section>
  )
}

export default withSitecoreContext()(LazySection)
